<template>
  <button
    type="button"
    :class="[
      'w-full inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium transition',
      bgClass,
      hoverClass,
      textClass,
      marginClass,
      disabled ? 'opacity-50 cursor-not-allowed' : '',
      rounded ? ' rounded-md' : '',
    ]"
    :style="{ width: width }"
    :aria-label="ariaLabel"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot />
    <span>{{ text }}</span>
  </button>
</template>

<script setup>

const props = defineProps({
  text: { type: String, default: 'Logout' },
  url: { type: String, default: null },
  ariaLabel: { type: String, default: 'Logout' },
  width: { type: String, default: 'auto' },
  marginClass: { type: String, default: 'mt-0' },

  // color classes
  bgClass: { type: String, default: 'bg-gray-800' },
  hoverClass: { type: String, default: 'hover:bg-gray-700' },
  textClass: { type: String, default: 'text-white' },
  rounded: {type: Boolean, default: false},

  // disabled state
  disabled: { type: Boolean, default: false }
})

const emit = defineEmits(['click'])

function handleClick(event) {
  if (!props.disabled) {
    emit('click', event)     // still emit the click
    if (props.url) {
      window.location.href = props.url
    }
  }
}</script>
